<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">META</h4>
                  <p class="mb-0">Olvidé mi contraseña.</p>
                </div>
                <argon-alert v-if="showAlertOk" color="success" :dismissible="true" @close-alert="closeAlertOk">
                  Se ha enviado una notificacion a tu correo
                </argon-alert>
                <argon-alert v-if="showAlertFail" color="danger" :dismissible="true" @close-alert="closeAlertFail">
                  Ocurrio un error, intentalo en unos minutos
                </argon-alert>
                <div class="card-body">
                  <form @submit.prevent="onSubmit" role="form">
                    <div class="mb-3">
                      <label for="email">Correo electrónico:</label>
                      <argon-input v-model="userForm.email" type="email" placeholder="Email" name="email" size="lg" />
                    </div>
                    <div class="text-center">
                      <argon-button type="submit" class="mt-4" variant="gradient" color="primary" fullWidth size="lg">
                        Enviar
                      </argon-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://www.libramientoslp.mx/images/bgContacto.png');
                      background-size: cover;">
                <span class="mask bg-gradient-primary opacity-6"></span>
                <h1 class="mt-5 text-white font-weight-bolder position-relative">"META"</h1>
                <h4 class="text-white position-relative">
                  Mexicana de Técnicos en Autopistas
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
  
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from '@/components/ArgonAlert.vue';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "Forgot",
  components: {
    ArgonInput,
    ArgonButton,
    ArgonAlert,
  },
  data() {
    return {
      showAlertOk: false,
      showAlertFail: false,
      userForm: {
        email: '',
      },
    };
  },
  methods: {
    onSubmit() {
      this.plain
        .post("/reset_password_token", { email: this.userForm.email })
        .then((response) => {
          console.log(response)
          this.showAlertOk = true
          this.userForm.email = ''
        })
        .catch((error) => {
          console.log("Error al olvidar contrasena", error);
          this.showAlertFail = true
        });
    },
    closeAlertOk(){
      this.showAlertOk = false;
    },
    closeAlertFail(){
      this.showAlertFail = false;
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
};
</script>